"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const Resource_1 = __importDefault(require("../../../Resource"));
const EPatrimoineRevenusGroups_1 = require("../../../../enums/Scpi/PhysicalPerson/Groups/EPatrimoineRevenusGroups");
class SubRevenuChargeRequestResource extends Resource_1.default {
}
exports.default = SubRevenuChargeRequestResource;
__decorate([
    (0, class_validator_1.ValidateIf)((obj) => obj.nature !== undefined && obj.nature !== "", {
        groups: [EPatrimoineRevenusGroups_1.EPatrimoineRevenusGroups.revenuCharge],
    }),
    (0, class_validator_1.IsString)({ groups: [EPatrimoineRevenusGroups_1.EPatrimoineRevenusGroups.revenuCharge] }),
    (0, class_transformer_1.Expose)({ groups: [EPatrimoineRevenusGroups_1.EPatrimoineRevenusGroups.revenuCharge] }),
    __metadata("design:type", String)
], SubRevenuChargeRequestResource.prototype, "nature", void 0);
__decorate([
    (0, class_validator_1.ValidateIf)((obj) => obj.montantMensuel !== undefined && obj.montantMensuel.toString() !== "", {
        groups: [EPatrimoineRevenusGroups_1.EPatrimoineRevenusGroups.revenuCharge],
    }),
    (0, class_validator_1.IsNumber)(undefined, { groups: [EPatrimoineRevenusGroups_1.EPatrimoineRevenusGroups.revenuCharge] }),
    (0, class_validator_1.IsPositive)({ groups: [EPatrimoineRevenusGroups_1.EPatrimoineRevenusGroups.revenuCharge] }),
    (0, class_validator_1.Min)(0, { groups: [EPatrimoineRevenusGroups_1.EPatrimoineRevenusGroups.revenuCharge], context: [0] }),
    (0, class_validator_1.Max)(99999999.99, { groups: [EPatrimoineRevenusGroups_1.EPatrimoineRevenusGroups.revenuCharge], context: [99999999.99] }),
    (0, class_transformer_1.Expose)({ groups: [EPatrimoineRevenusGroups_1.EPatrimoineRevenusGroups.revenuCharge] }),
    __metadata("design:type", Number)
], SubRevenuChargeRequestResource.prototype, "montantMensuel", void 0);
